import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiFehler } from "./client";

/** Der eine QueryClient der App mit dem globalen Handler fuer 401. */
export function abfragenAnlegen(): QueryClient {
  /** Sitzung weg (abgemeldet, etwa in einem anderen Tab, oder abgelaufen): alle Daten verwerfen und zur
   *  Anmeldung, statt alte Daten mit „Nicht angemeldet“ stehen zu lassen (Verifier W4, F11). */
  function sitzungWeg(fehler: unknown) {
    if (!(fehler instanceof ApiFehler) || fehler.status !== 401) return;
    abfragen.removeQueries({ predicate: (q) => q.queryKey[0] !== "ich" });
    abfragen.setQueryData(["ich"], null);
  }

  const abfragen: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError: sitzungWeg }),
    // W20f: ein falsches Passwort ist seit Server W20d (f81264a) ueberall 403, 401 heisst nur noch „abgemeldet“
    mutationCache: new MutationCache({ onError: sitzungWeg }),
    defaultOptions: {
      // 4xx sind Antworten, keine Stoerung: nicht wiederholen.
      queries: { retry: (anzahl, fehler) => !(fehler instanceof ApiFehler && fehler.status < 500) && anzahl < 1 },
      // W82 Web-5h1 (K47, BS30): ohne Netz pausiert TanStack Query Mutationen im Standardmodus („online“) und sendet sie beim
      // Wiederverbinden von selbst, auch nach dem Abbruch durch die Zeitgrenze eines Blatts. „always“: ohne Netz scheitert das
      // Sichern sofort mit dem Netz-Satz, später geht nichts mehr los (Vorbild `abfragen.ts`, Karte des Gaist)
      mutations: { networkMode: "always" },
    },
  });
  return abfragen;
}
